import { isClient } from '@itau-loans-www/utils'
import { getSourceUrl } from '@itau-loans-www/utils'
import { storage } from '@itau-loans-www/utils'

const trackLeadComplete = ({ product_code }) => {
  const { leadId } = storage.session.getItem('token')

  if (isClient()) {
    if (window.fbq) {
      window.fbq('trackCustom', 'lead_complete', {
        product_code: product_code,
        source_url: getSourceUrl(),
        lead_id: leadId
      })
      console.log('[ Pixel ] - Track Lead Complete')
    }
  }
}

export default {
  trackLeadComplete
}
